import React from 'react';
import css from './css.module.less';
import { Button } from 'src/components/Antd';
const Clickable = (props) => {
  const { children, className, ...rest } = props;
  return (
    <Button
      type='link'
      block
      className={`${css.container} ${className || ''}`}
      {...rest}>
      {children}
    </Button>
  );
};
export default Clickable;
